<template>
    <div>
      <div class="col-md-6 col-sm-6 selector">
        <select class="form-control" name="season" v-model="selectedSeason" required>
            <option value="">--- Saison ---</option>
            <option value="Printemps">Printemps</option>
            <option value="Eté">Eté</option>
            <option value="Automne">Automne</option>
            <option value="Hiver">Hiver</option>
        </select>
      </div> 
      <div class="col-md-6 col-sm-6 selector">
        <select class="form-control" name="type" v-model="selectedType" required>
            <option value="">--- Type d'activité ---</option>
            <option v-for="type in types" v-if="type.season === selectedSeason">{{ type.name }}</option>
        </select>
      </div>
    </div>
</template>

<script>
export default {

  name: 'ActivitySelectList',
  props: {
    season: String,
    type: String
  },
  data () {
    return {
        selectedType: '',
        selectedSeason: '',
        types: undefined
    }
  },
  mounted () {
      axios.get('/activityType/get')
        .then((res) => {
          this.types = res.data
          this.selectedType = this.type
          this.selectedSeason = this.season
        })
        .catch((err) => {
          this.$swal('wooops')
        })
  }
};
</script>

<style lang="css" scoped>
</style>
